const KEY = "tp_android_app";

// Google Play (TWA) launches report an android-app:// referrer; PWABuilder can also append ?source=twa.
export function detectPlatform() {
  const params = new URLSearchParams(window.location.search);
  if (document.referrer.startsWith("android-app://") || params.get("source") === "twa") {
    sessionStorage.setItem(KEY, "1");
  }
}

export const isAndroidApp = () => sessionStorage.getItem(KEY) === "1";

export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    });
  }
}
